import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.917 2.784A3.12 3.12 0 0 1 6 2h6c.764 0 1.514.272 2.083.784.572.515.917 1.237.917 2.016V12a3 3 0 0 1 3 3v2a1 1 0 0 0 2 0v-6.17a1 1 0 0 0-.295-.71l-.002-.003-3.41-3.41a1 1 0 0 1 1.414-1.414L21.115 8.7l.001.001a3 3 0 0 1 .884 2.13V17a3 3 0 0 1-6 0v-2a1 1 0 0 0-1-1v6a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2V4.8c0-.779.345-1.501.917-2.016M5 10v10h8V10zm8-2H5V4.8c0-.176.077-.37.255-.53A1.12 1.12 0 0 1 6 4h6c.297 0 .564.107.745.27.178.16.255.354.255.53z"
    }, null, -1)
  ]))]))
}
export default { render: render }